export function initTooltip() {
  const search = document.querySelector('gmf-search');
  const tooltip = document.getElementById('searchTooltip');
  if (!search || !tooltip) return;

  function positionTooltip() {
    const rect = search!.getBoundingClientRect();
    tooltip!.style.left = `${rect.right + 10 + window.scrollX}px`;
    tooltip!.style.top = `${rect.top + window.scrollY}px`;
  }

  search.addEventListener('mouseenter', () => {
    tooltip.setAttribute('visible', '');
    positionTooltip();
  });
  search.addEventListener('mouseleave', () => {
    tooltip.removeAttribute('visible');
  });

  window.addEventListener('resize', positionTooltip);
  window.addEventListener('scroll', positionTooltip, {passive: true});
}
